import TableElement from 'components/organisms/players-to-exchange/table-elements/table-element';
import React from 'react';
import TeamLogo from 'components/molecules/team-logo';
import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';
import BuilderInterface from 'components/organisms/players-to-exchange/available-players/builder-interface';
import LineupInterface from 'interfaces/lineups-data-interfaces/lineup-interface';
import BasePlayerBuilder from 'components/organisms/players-to-exchange/available-players/base-player-builder';

export default class TiersBuilder extends BasePlayerBuilder implements BuilderInterface {
    getTableHead(): Array<TableElement> {
        const elements = {
            'td-pos': 'Pos',
            'td-name': 'Name',
            'td-tier': 'Tier',
            'td-team': 'Team',
            'td-opponent': 'Opponent',
            'td-line': 'Line Group',
            'td-pp-line': 'PP Line',
            'td-fpts': 'Fpts',
            '': '',
        };

        return this.buildRow(elements);
    }

    getTableBody(
        player: PlayerInterface,
        substitutablePlayer: PlayerInterface,
        lineup: LineupInterface,
        salaryCapExceeded: boolean,
    ): Array<TableElement> {
        const elements = {
            'td-pos': player.positionName,
            'td-name': player.name,
            'td-tier': player.rosterPosition,
            'td-team': <TeamLogo teamName={player.team} />,
            'td-opponent': <TeamLogo teamName={player.opponent} />,
            'td-line': player.lineGroup,
            'td-pp-line': player.ppLine,
            'td-fpts': player.getUserPointsByMode(),
            '': this.getSwapButton(salaryCapExceeded, substitutablePlayer, player, lineup),
        };

        return this.buildRow(elements);
    }
}
